import _ from "lodash";

// 平铺数据data转为树形结构
export function filterTree(list) {
  let result = []; // 结果集
  let map = {};

  for (let item of list) {
    map[item.id] = { ...item, children: [] }; // 将源数组中每一个对象的id作为key，将当前对象所有属性和新增属性chilrden作为value。

    // 遍历一遍源数组
  }

  for (let item of list) {
    if (!item.pid) {
      // console.log("map[item.pid]--->", list, map[item.id])
      // 当pid为0时，添加到结果集
      let newItem = map[item.id]; // 注意！这里一定要将map[item.id] 赋值给新变量，这样newItem就和map[item.id]指向同一个内存地址了，达到数据共享
      result.push(newItem);
    } else {
      map[item.pid]?.children.push(map[item.id]); // 将key为当前id的对象，添加到key等于pid的对象的chilrden中
    }
  }
  // 便利map 删除children为空的children属性
  for (let key in map) {
    if (map[key].children.length === 0) {
      delete map[key].children;
    }
  }

  return result;
}
// 平铺数据data转为树形结构
export function filterCategoryTree(data) {
  const result = [];
  if (!Array.isArray(data)) {
    return result;
  }
  let copyData = _.cloneDeep(data); //深拷贝
  const map = {};
  copyData.forEach((item) => {
    map[item.id] = item;
  });
  copyData.forEach((item) => {
    const parent = map[item.pid];
    if (parent) {
      parent.children || (parent.children = []).push(item);
    } else {
      result.push(item);
    }
  });
  return result;
}
// 树形转平铺
export function treeToFlat(tree) {
  let result = [];
  tree.forEach((item) => {
    result.push(item);
    if (item.children) {
      result = result.concat(treeToFlat(item.children));
    }
  });
  return result;
}
// 打印pdf
// baseData是后端传来的base64
export function filePrint(baseData) {
  let blob = dataURLtoBlob(baseData);
  let src = window.URL.createObjectURL(blob);
  handlePrint(src);
}

//生成打印窗口<iframe></iframe>用于打印
const handlePrint = function (pdf) {
  if (document.getElementById("print-iframe")) {
    document.body.removeChild(document.getElementById("print-iframe"));
  }
  //判断iframe是否存在，不存在则创建iframe
  let iframe = document.getElementById("print-iframe");
  if (!iframe) {
    iframe = document.createElement("IFRAME");
    let doc = null;
    iframe.setAttribute("src", pdf);
    iframe.setAttribute("id", "print-iframe");
    iframe.setAttribute(
      "style",
      "position:absolute;width:0px;height:0px;left:-500px;top:-500px;"
    );
    document.body.appendChild(iframe);
    doc = iframe.contentWindow.document;
    doc.close();
    iframe.contentWindow.focus();
  }
  iframe.contentWindow.print();
};

//best64转Blob
const dataURLtoBlob = function (baseData) {
  var bstr = atob(baseData);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {
    type: `application/pdf;charset-UTF-8;application/vnd.ms-excel`,
  });
};

export const setTag = (val) => {
  return sessionStorage.setItem("tagList", JSON.stringify(val));
};
